<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
import {mapGetters} from "vuex";

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (!localStorage.getItem('token')) {
          this.$router.push({path: '/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    reloadPage() {
      // 导航到指定页面
      this.$router.go(-1)
        // 强制刷新页面
      this.$nextTick(() => {
        setTimeout(() => {
          window.location.reload();
        }, 100);
      })
    }
  },
  created() {
    this.getBaseInfo();
  },
  watch: {
    activeLang(newval) {
      console.log("=>(App.vue:51) activeLang", newval);
      this.reloadPage();
    }
  }
}
</script>

<style>
body .van-toast {
  font-size: 30px;
  padding: 14px;
  line-height: 50px;
  width: fit-content !important;
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*, :after, :before {
  box-sizing: border-box;
}
.van-pull-refresh {
  min-height: 100%;
}

/* PC端适配：保持移动端样式，限制最大宽度并居中 */
@media (min-width: 768px) {
  html, body {
    background-color: #f2f2f5 !important;
    margin: 0;
    padding: 0;
    width: 100%;
    overflow-x: hidden;
  }
  
  #app {
    max-width: 430px;
    width: 430px;
    margin: 0 auto;
    position: relative;
    background-color: #ffffff;
    min-height: 100vh;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  /* PC端重置toast的vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733) */
  body .van-toast {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    padding: 8px; /* 14px * 0.5733 ≈ 8px */
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  body .van-toast .van-toast__icon {
    font-size: 29px; /* 50px * 0.5733 ≈ 29px */
  }
}
</style>
